import { Validator } from '@vista-digital/validator';
import { HeadingLevel } from '../../../../subcomponents/heading/heading';
/**
 * Default configuration options for the Film Title component.
 */
export const defaultFilmTitleConfig = {
    headingLevel: HeadingLevel.H1
};
export const filmTitleConfigValidatorSchema = {
    headingLevel: Validator.oneOf(Object.values(HeadingLevel))
};
export const filmTitleConfigValidator = Validator.object(filmTitleConfigValidatorSchema);
